// Copyright (c) 2019 Deere & Company

import './modal.scss';
import { FormattedMessage } from 'react-intl';
import Modal from 'react-bootstrap/Modal';
import PropTypes from 'prop-types';
import React from 'react';

export const ConfirmationModal = props => (
    <div className="confirmation-modal">
        <Modal dialogClassName="confirmation-modal" backdrop={true} onHide={props.onHide} show={props.isOpen} size="sm">
            <Modal.Header>{props.header}</Modal.Header>
            <Modal.Body>
                <span className="warning-icon" />
                {props.body}
            </Modal.Body>
            <Modal.Footer>
                <button type="button" onClick={props.onCancel}>
                    <FormattedMessage id="CANCEL" />
                </button>
                <button type="button" className="primary-button" onClick={props.onConfirm}>
                    <FormattedMessage id="CONFIRM" />
                </button>
            </Modal.Footer>
        </Modal>
    </div>
);

ConfirmationModal.propTypes = {
    body: PropTypes.node.isRequired,
    header: PropTypes.node.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onHide: PropTypes.func.isRequired,
};
